/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Filterprogressstatus_Completed4Inputs */

const nl_enums_filterprogressstatus_completed4 = /** @type {(inputs: Enums_Filterprogressstatus_Completed4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandeld`)
};

/**

* @param {Enums_Filterprogressstatus_Completed4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_filterprogressstatus_completed4 = /** @type {((inputs?: Enums_Filterprogressstatus_Completed4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Filterprogressstatus_Completed4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_filterprogressstatus_completed4(inputs)
});
export { enums_filterprogressstatus_completed4 as "enums.FilterProgressStatus.Completed" }